import React, {FC} from 'react'

import cn from 'classnames/bind'

import RequiredTip from 'components/blocks/RequiredTip'

import s from './FormTips.module.scss'

const cx = cn.bind(s)

interface IFormTipsProps {
	className?: string
}

const FormTips: FC<IFormTipsProps> = ({className}) => {
	return (
		<div className={cx('tips', className)}>
			<FormTip color="orange" value="Editable fields" />
			<FormTip value="Best not to edit" />
			<RequiredTip />
		</div>
	)
}

interface IFormTipProps {
	color?: string
	value: string
}

const FormTip: FC<IFormTipProps> = ({color = 'blue', value}) => {
	return (
		<p className={cx('tip')}>
			<span className={cx('tip__marker', color)} />
			<span className={cx('tip__text')}>{value}</span>
		</p>
	)
}

FormTips.displayName = 'FormTips'

export default FormTips
